import { useAuth } from '../../contexts/AuthContext'
import HeaderShadowSeparator from '../parts/separator/HeaderShadowSeparator'
import GlobalNavLink from '../parts/navlinks/GlobalNavLink'

const LandingPageMainSection = () => {

    const { currentUser } = useAuth()

    const cssSection = 'relative w-full h-[33vh] global-px pt-6 pb-12 bg-orangeImg bg-no-repeat bg-cover flexJustifyItemsCenter flex-col gap-6 text-center text-darkRed z-20 shadow-md shadow-darkOrange md:text-white md:shadow-lg md:shadow-darkOrange lg:pt-28 lg:gap-12'
    const sectionCss = currentUser ? `${cssSection} md:h-[75vh] lg:h-[85vh]` : `${cssSection} md:h-[89vh]`

    return (
        <section className={sectionCss}>
            <HeaderShadowSeparator css="bg-ivory" />
            <div className='hidden justify-center items-center md:flex md:h-4/6 md:w-full md:-mt-0 lg:-mt-20'>
                <GlobalNavLink type="landingPage" to={currentUser ? "/wishes" : "/login"} txt="À vos souhaits !" css="bg-landingPageDarkRed shadow-lg shadow-landingPageDarkRed text-white text-2xl rounded-lg px-6 py-6 md:flex md:justify-center md:items-center md:w-9/12 md:text-6xl md:py-10" />
            </div>
            <div className='flexJustifyItemsCenter flex-col gap-4 text-darkRed md:flex-row md:gap-24 md:w-9/12 md:-mt-10 md:justify-center md:items-start'>
                <h1 className='font-bold text-2xl md:text-3xl md:leading-relaxed'>Votre créateur de liste de souhaits en ligne</h1>
                <span className='text-xl md:text-2xl md:leading-loose'>Le meilleur moyen de trouver le cadeau idéal !</span>
            </div>
        </section>
    )
}

export default LandingPageMainSection